import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";

const ProgressMilestones = ({ milestones = [], currentMilestone = 0, campaignActive = false }) => {
  return (
    <div className="gn-milestones">
      <div className="gn-milestones-header">
        <span>
          Progress{currentMilestone > 0 ? ` — Milestone ${currentMilestone}/5` : ""}
        </span>
        {campaignActive && (
          <Link to="/invite-and-rise" className="gn-campaign-badge">
            Invite & Rise
          </Link>
        )}
      </div>
      <div className="gn-milestone-bar">
        {[1, 2, 3, 4, 5].map((n) => (
          <div
            key={n}
            className={`gn-milestone-step${n <= currentMilestone ? " reached" : ""}`}
          />
        ))}
      </div>
      <ul className="gn-milestone-list">
        {milestones.map((m) => (
          <li key={m.number} className={m.reached ? "reached" : ""}>
            <span className="gn-milestone-dot" />
            {m.label}
          </li>
        ))}
      </ul>
    </div>
  );
};

ProgressMilestones.propTypes = {
  milestones: PropTypes.array,
  currentMilestone: PropTypes.number,
  campaignActive: PropTypes.bool,
};

export default ProgressMilestones;
